import invariant from "tiny-invariant";

export function startsWithPrefix(prefix: string, path: string) {
    return path.startsWith(prefix) && (path.length === prefix.length || path[prefix.length] === "/");
}

/**
 * Remove a prefix from a path, if it matches.
 *
 * NB: Can return an empty string if the path is exactly the prefix.
 */
export function removePrefix(prefix: string, path: string) {
    return matchPath(prefix, path) ?? path;
}

/**
 * Get the path of {@link fullPath} based on {@link prefix}.
 *
 * Returns "/" if the path is exactly the prefix.
 */
export function getBasedFrom(prefix: string, fullPath: string) {
    const remaining = removePrefix(prefix, fullPath);
    return remaining === "" ? "/" : remaining;
}

/**
 * Checks that {@link path} starts with {@link prefix}.
 * @returns The remaining path after the prefix, or `null` if the prefix does not match.
 * @example
 *   if (matchPath("/foo", location.pathname) != null) { ... }
 */
export function matchPath(prefix: string, path: string) {
    invariant(prefix.startsWith("/"), "Prefix must start with a slash");
    invariant(!prefix.endsWith("/") || prefix === "/", "Prefix must not end with a slash");

    if (!startsWithPrefix(prefix, path)) {
        return null;
    }
    return path.slice(prefix.length);
}

export function isFinalSegment(path: string) {
    return path === "" || path === "/";
}

export function addTrailingSlash(path: string) {
    return path.endsWith("/") ? path : `${path}/`;
}
